export function Stat({ label, value, tone }) {
  const color = tone === "green" ? "text-[#2F6F4E]" : tone === "red" ? "text-[#8A2526]" : "text-[#1A1A18]";
  return (
    <div className="bg-white border border-[#E5E3DB] p-3">
      <div className="text-[11px] uppercase tracking-wider text-[#68665E] font-semibold">{label}</div>
      <div className={`text-lg font-bold mt-1 ${color}`}>{value}</div>
    </div>
  );
}

export function FilterGroup({ options, value, onChange, testid }) {
  return (
    <div className="inline-flex border border-[#E5E3DB] bg-white" data-testid={testid}>
      {options.map((o) => (
        <button key={o.key} onClick={() => onChange(o.key)}
          className={`px-3 py-1.5 text-sm ${value === o.key ? "bg-[#1A1A18] text-white" : "text-[#68665E] hover:bg-[#F5F3EC]"}`}
          data-testid={`${testid}-${o.key || "all"}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
